import { cn } from '@/utils/cn';
import { DIFF_BG, DIFF_SIGN, DIFF_SIGN_COLOR } from './constants';
import type { DiffFieldRow } from './types';

interface FieldsDiffProps {
  rows: DiffFieldRow[];
  onlyChanges: boolean;
  baseLabel: string;
  targetLabel: string;
}

export const FieldsDiff = ({ rows, onlyChanges, baseLabel, targetLabel }: FieldsDiffProps) => {
  const visible = onlyChanges ? rows.filter((row) => row.status !== 'unchanged') : rows;
  return (
    <div>
      <div className="grid grid-cols-[16px_1fr_1fr_1fr] gap-3 px-3 h-7 items-center border-b border-neutral-100 bg-white text-[10.5px] font-semibold uppercase tracking-wider text-neutral-500">
        <span />
        <span>Parametr</span>
        <span>{baseLabel}</span>
        <span>{targetLabel}</span>
      </div>
      <div className="divide-y divide-neutral-100">
        {visible.map((row) => (
          <div
            key={row.key}
            data-diff-change={row.status !== 'unchanged' || undefined}
            className={cn(
              'grid grid-cols-[16px_1fr_1fr_1fr] gap-3 px-3 py-2 items-baseline',
              DIFF_BG[row.status]
            )}
          >
            <span className={cn('font-mono text-[12px] leading-5', DIFF_SIGN_COLOR[row.status])}>
              {DIFF_SIGN[row.status]}
            </span>
            <div>
              <div className="text-[13px] text-neutral-900">{row.label}</div>
              {row.note && <div className="text-[11px] text-neutral-500 mt-0.5">{row.note}</div>}
            </div>
            <span
              className={cn(
                'font-mono text-[12px]',
                row.old
                  ? row.status === 'unchanged'
                    ? 'text-neutral-600'
                    : 'text-red-700 line-through decoration-red-400'
                  : 'text-neutral-300'
              )}
            >
              {row.old || '—'}
            </span>
            <span
              className={cn(
                'font-mono text-[12px]',
                row.status === 'unchanged' ? 'text-neutral-600' : 'text-emerald-800 font-medium'
              )}
            >
              {row.new ?? '—'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
